<template>
  <div>
    <loader v-if="!isLoaded"></loader>

      <!----select stages ----->
      <div class="row">
        <div class="col-md-12">
          <button type="button"
                  class="btn btn-light btn-sm back"
                  @click.prevent="hideTasks(true)">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back' | trans}}</span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h1 v-if="isNew && !protocol.isDraft" class="page-title">
            {{'protocol.newProtocol' |
            trans}}</h1>
          <h1 v-if="!isNew && !protocol.isDraft" class="page-title">
            {{'protocol.editProtocol' |
            trans}}</h1>
          <h1 v-if="protocol.isDraft" class="page-title">
            {{'protocol.auto_save_version' | trans}} {{protocol.updatedAt.date |
            toLocaleDateTime}}</h1>
          <h3 class="page-sub-title">
            {{currentStage.title}}: {{currentStage.description}}</h3>
        </div>
      </div>

      <!---- select task types ----->

      <div class="alert alert-secondary mt-2">
        <div class="form-group row">
          <div class="col-md-12">
            <h4 class="row-title">{{'protocol.stimuluses' | trans}}</h4>
            <h5 class="row-title_subsitle mb-4">{{'protocol.change_stimul_position' | trans}}</h5>
          </div>

          <div class="tasks col-md-12" id="tasks" v-if="tasks">
            <table class="table table-sm">
                <draggable
                    :list="tasks"
                    ghost-class="ghost"
                    tag="tbody"
                    @start="dragging = true"
                    @end="dragging = false"
                    handle=".drag-btn"
                >
                  <tr v-for="task in tasks" :key="task.id" :class="{'table-secondary': task.levelUuid}">
                    <td class="name-field">
                      {{task.description}}
                    </td>
                    <td>
                      <span v-if="task.phaseTypeId === 5">{{'protocol.phase_mastering' | trans}}</span>
                      <span v-if="task.phaseTypeId === 3">{{'protocol.phase_support' | trans}}</span>
                      <span v-if="task.phaseTypeId == 3 && currentIntervalType(task.intervalTypeId)"> / {{currentIntervalType(task.intervalTypeId)}} </span>
                    </td>
                    <td class="table-actions">
                      <mdc-checkbox v-model="task.active" @change="changeActive(task)"/>
                    </td>
                    <td class="text-right action-cell"  v-if="task.active">

                      <button type="button"
                              class="btn btn-primary btn-sm btn-rounded"
                              @click.prevent="onEditBtnClick(task)">
                        <i class="material-icons button-primary btn-fixed">edit</i>
                      </button>
                    </td>
                    <td class="text-right action-cell"  v-if="task.active">
                      <span class="drag-btn align-top">draggable</span>
                    </td>
                  </tr>
                </draggable>

            </table>
          </div>

          <div class="col-10 col-md-11">
            <mdc-textfield type="text"
                           :label="'protocol.buttons.addStimulus' | trans"
                           name="addStimulusItem"
                           :class="{'is-invalid': errors.has('addStimulusItem')}"
                           v-validate="'max:1000'"
                           v-model="addStimulusItem"
                           data-vv-validate-on="none"
                           :data-vv-as="'protocol.buttons.addStimulus' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('addStimulusItem')">
                      <strong>{{ errors.first('addStimulusItem') }}</strong>
                  </span>

          </div>
          <div class="col-2 col-md-1">
            <button type="button"
                    class="btn btn-sm btn-rounded btn-add-grey"
                    @click.prevent="addTask(addStimulusItem)">
              <i class="material-icons button-primary btn-fixed">add</i>
            </button>
          </div>

          <!----------- tasks ------------------->
        </div>
      </div>


    <div class="row form-group" v-if="mastering">

          <div class="col-md-12 mt-3" v-for="(level, index) in mastering.levels">
            <div class="alert alert-secondary">
              <div class="row">
                <div class="col-md-9">
                  <mdc-textfield type="text"
                                 :ref="'level_' + index"
                                 :name="'level_' + index"
                                 :label="levelTitle(index)"
                                 class="required"
                                 :class="{'is-invalid': errors.has('level_' + index)}"
                                 v-validate="'required|max:1000'"
                                 v-model="level.description"
                                 data-vv-validate-on="none"
                                 :data-vv-as="'protocol.describeMandReaction', {number: index + 1} | trans"/>
                </div>
                <div class="col-md-3 text-right">
                  <button type="button"
                          class="btn btn-link secondary-link btn-sm"
                          v-if="index > 2"
                          @click.prevent="removeLevel(index)">
                    {{'protocol.buttons.delete' | trans}}
                  </button>

                  <button type="submit"
                          class="btn btn-primary btn-rounded copy-btn ml-1"
                          @click.prevent="addGroup(index)">
                  </button>
                </div>
                <div class="col-md-4 mt-2" v-for="(group, groupIndex) in level.groups">
                    <ul class="list-group">
                      <li class="list-group-item list-group-item-light">
                        {{'protocol.set' | trans}}  {{groupIndex + 1}}
                        <button type="button"
                                class="btn btn-primary btn-sm btn-rounded float-right"
                                @click.prevent="protocol.assigneeId ? acceptDeleteSet(index, groupIndex) : deleteGroup(index, groupIndex)">
                          <i class="material-icons button-primary btn-fixed">close</i>
                        </button>
                        <div class="float-right text-block__slash mr-2" v-if="group.sessions">
                          <span v-for="session in group.sessions.slice().reverse()">{{session.masteringRatio}}%</span>
                        </div>
                      </li>
                      <li v-for="stimul in group.stimuli" class="list-group-item">
                        {{stimulDescrition(stimul.globalUuid)}}
                      </li>
                    </ul>


                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <button type="button"
                    class="btn btn-primary"
                    @click.prevent="addLevel(hintLevel)">
              {{'protocol.add_level' | trans}}
            </button>
      
          </div>

    </div>

    <div class="form-group row">

      <div class="col-md-12 mt-4">
        <h4 class="row-title">
          {{'protocol.dtt_phase_title' | trans}}
        </h4>

      </div>

      <div class="col-md-12 mt-3">

        <div class="box-shadow"  v-if="currentStage">
          <div class="row">

            <div class="col-12"><h4 class="row-title">
              {{'protocol.setup_mastering' | trans}}
            </h4></div>

            <div class="col-12">
              <div class="row">
                <div class="col-md-4 required">
                  <v-select name="taskType"
                            ref="taskType"
                            id="taskType"
                            :options="taskTypesList"
                            label="title"
                            :class="{'is-clear': !mastering.taskType, 'is-invalid': errors.has('taskTypes')}"
                            v-validate="'required'"
                            data-vv-validate-on="none"
                            v-model=mastering.taskType
                            :data-vv-as="'protocol.task_type' | trans">
                    <template slot="no-options">
                      <div @mousedown.stop="">
                        {{ 'protocol.no_data' | trans }}
                      </div>
                    </template>
                  </v-select>
                  <label class="mdc-floating-label" :class="{'is-invalid': errors.has('taskType')}">{{'protocol.task_type' |
                    trans}} <sup><mdc-icon class="help_icon" icon="help"  v-tooltip.top-center="msg"></mdc-icon></sup></label>
                  <span class="invalid-feedback"
                        v-if="errors.has('taskType')">
                      <strong>{{ errors.first('taskType') }}</strong>
                  </span>
                </div>

              </div>
            </div>

            <div class="col-md-12">
              <div class="row">

                <div class="col-md-12 choose-block mt-4">
                  <p class="sub-title">{{'protocol.condition_next' | trans}}:</p>

                  <div class="mdc-wrapper" :class="{'is-invalid': errors.has('condition_procent_nextLevel')}">
                    &ge; <input id="condition_procent_nextLevel"
                                   ref="condition_procent_nextLevel"
                                   min=89
                                   max=100
                                   type="number"
                                   v-on:keydown="changeNumber"
                                   name="condition_procent_nextLevel"
                                   :class="{'is-invalid': errors.has('condition_procent_nextLevel')}"
                                   v-model="mastering.masteringConditions.nextLevel.ratio"
                                   v-validate="'min_value:89|max_value:100|numeric'"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'protocol.condition_procent' | trans"/>
                    {{'protocol.percent_block' | trans}}
                    <div class="mdc-select-wrapper">
                      <v-select name="condition_session"
                                id="condition_session"
                                ref="condition_session_nextLevel"
                                :options="condition_list"
                                data-vv-validate-on="none"
                                v-model="mastering.masteringConditions.nextLevel.blockCount"
                                :data-vv-as="'protocol.condition_session' | trans">
                        <template slot="no-options">
                          <div @mousedown.stop="">
                            {{ 'protocol.no_data' | trans }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    {{'protocol.blocks' | trans}}
                  </div>
  
                  <span class="invalid-feedback"
                        v-if="errors.has('condition_procent_nextLevel')">
                      <strong>{{ errors.first('condition_procent_nextLevel') }}</strong>
                  </span>

                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="row">

                <div class="col-md-12 choose-block mt-4">
                  <p class="sub-title">{{'protocol.condition_return' | trans}}:</p>

                  <div class="mdc-wrapper" :class="{'is-invalid': errors.has('condition_procent_prevLevel')}">
                    &lt; <input id="condition_procent_prevLevel"
                                   ref="condition_procent_prevLevel"
                                   min=0
                                   max=100
                                   type="number"
                                   v-on:keydown="changeNumber"
                                   name="condition_procent_prevLevel"
                                   :class="{'is-invalid': errors.has('condition_procent_prevLevel')}"
                                   v-model="mastering.masteringConditions.previousLevel.ratio"
                                   v-validate="'min_value:0|max_value:' + mastering.masteringConditions.nextLevel.ratio  + '|numeric'"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'protocol.condition_procent' | trans"/>
                    {{'protocol.percent_block' | trans}}
                    <div class="mdc-select-wrapper">
                      <v-select name="condition_session"
                                id="condition_session_prevLevel"
                                ref="condition_session_prevLevel"
                                :options="condition_list"
                                data-vv-validate-on="none"
                                v-model="mastering.masteringConditions.previousLevel.blockCount"
                                :data-vv-as="'protocol.condition_session' | trans">
                        <template slot="no-options">
                          <div @mousedown.stop="">
                            {{ 'protocol.no_data' | trans }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    {{'protocol.blocks' | trans}}
                  </div>
                  <span class="invalid-feedback"
                        v-if="errors.has('condition_procent_prevLevel')">
                      <strong>{{ errors.first('condition_procent_prevLevel') }}</strong>
                  </span>

                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="row">

                <div class="col-md-12 choose-block mt-4">
                  <p class="sub-title">{{'protocol.condition_mastered_usd' | trans}}:</p>

                  <div class="mdc-wrapper" :class="{'is-invalid': errors.has('condition_procent_nextPhase')}">
                    &ge; <input id="condition_procent_nextPhase"
                                   ref="condition_procent_nextPhase"
                                   min=89
                                   max=100
                                   type="number"
                                   v-on:keydown="changeNumber"
                                   name="condition_procent_nextPhase"
                                   :class="{'is-invalid': errors.has('condition_procent_nextPhase')}"
                                   v-model="mastering.masteringConditions.nextPhase.ratio"
                                   v-validate="'min_value:89|max_value:100|numeric'"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'protocol.condition_procent' | trans"/>
                    {{'protocol.percent_next_block' | trans}}
                    <div class="mdc-select-wrapper">
                      <v-select name="condition_session"
                                id="condition_session_nextPhase"
                                ref="condition_session_nextPhase"
                                :options="condition_list"
                                data-vv-validate-on="none"
                                v-model="mastering.masteringConditions.nextPhase.blockCount"
                                :data-vv-as="'protocol.condition_session' | trans">
                        <template slot="no-options">
                          <div @mousedown.stop="">
                            {{ 'protocol.no_data' | trans }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    {{'protocol.blocks' | trans}}
                  </div>
                  <span class="invalid-feedback"
                        v-if="errors.has('condition_procent_nextPhase')">
                      <strong>{{ errors.first('condition_procent_nextPhase') }}</strong>
                  </span>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-12 mt-3">

        <div class="box-shadow"  v-if="currentStage">
          <div class="row">
            <div class="col-12">
              <h4 class="row-title">
                {{'protocol.setup_support' | trans}}:
              </h4>
              <p class="gray-dark">{{'protocol.stimulus_intervals' |
                trans}}</p>
              <span class="invalid-feedback invalid"
                v-if="intervalError">
                  <strong>{{'protocol.interval_error' | trans}}</strong>
              </span>

              <table class="table table-sm">
                <thead class="thead-light">
                  <tr>
                    <th>{{'protocol.interval_name' | trans}}</th>
                    <th class="table-count">{{'protocol.interval_count' | trans}}</th>
                    <th class="table-actions"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="interval in intervals" :key="interval.index">
                    <td>
                      {{interval.name}}
                    </td>
                    <td class="table-count">
                      <mdc-textfield type="number"
                                     v-on:keydown="changeNumber"
                                     min=1
                                     name="interval_count"
                                     v-model="interval.count"
                                     data-vv-validate-on="none"
                                     v-validate="'min_value:1|numeric'"
                                     :data-vv-as="'protocol.interval_count' | trans"/>
                    </td>
                    <td>
                      <mdc-checkbox v-model="interval.checked"/>
                    </td>
                  </tr>
                </tbody>
              </table>
              <span class="invalid-feedback invalid"
                v-if="errors.has('interval_count')">
                  <strong>{{ errors.first('interval_count') }}</strong>
              </span>
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <button type="submit"
                class="btn btn-primary mr-2"
                @click.prevent="hideTasks(true)">
          {{'protocol.buttons.back_to_protocol' | trans}}
        </button>
      </div>
    </div>

    <add-hint-modal :visible="isModalHintVisible"
                    v-if="isModalHintVisible"
                    :stimulList="activeStimulList"
                    v-on:close="onModalClose"
                    v-on:cancel="onModalCancel"/>

    <task-usd-modal :visible="isModalVisible"
                  v-if="isModalVisible"
                  :stimul="stimul"
                  :intervals="intervals"
                  :data="currentStage.phases"
                  v-on:close="onModalUSDClose"
                  v-on:save="onModalSave"/>



    <mdc-dialog v-model="isModalAcceptPopup"
                :title="deletedSetItem"
                :accept="'buttons.continue' | trans"
                :cancel="'user.cancel' | trans"
                @accept="changeStimul"
                @cancel="closeStimul">

    </mdc-dialog>
  
    <mdc-dialog v-model="isModalDisablePopup"
                :title="deletedSetItem"
                :accept="'buttons.continue' | trans"
                :cancel="'user.cancel' | trans"
                @accept="disableStimul"
                @cancel="closeDisableStimul">
  
    </mdc-dialog>
  
    <mdc-dialog v-model="acceptDeleteSetPopup"
                :title="'protocol.delete_set' | trans"
                :accept="'buttons.continue' | trans"
                :cancel="'user.cancel' | trans"
                @accept="closeAcceptDeleteSetPopup"
                @cancel="cancelAcceptDeleteSetPopup">
  
    </mdc-dialog>

  </div>

</template>

<script>
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import isUndefined from 'lodash/isUndefined';
  import isString from 'lodash/isString';
  import forEach from 'lodash/forEach';
  import join from 'lodash/join';
  import isNull from 'lodash/isNull';
  import isEmpty from 'lodash/isEmpty';
  import includes from 'lodash/includes';
  import {Validator} from 'vee-validate';
  import forIn from 'lodash/forIn';
  import ConfirmModal from './ConfirmModal';
  import cloneDeep from 'lodash/cloneDeep';
  import filter from 'lodash/filter';
  import isInteger from 'lodash/isInteger';
  import parseInt from 'lodash/parseInt';
  import sortBy from 'lodash/sortBy';
  import {TRANSFER_CONDITION} from '../../protocols/constants.js';
  import draggable from 'vuedraggable';
  import AddHintModal from './AddHintModal';
  import TaskUsdModal from './TaskUSDModal';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import trim from 'lodash/trim';
  import toInteger from 'lodash/toInteger';
  import map from 'lodash/map';
  import Loader from '../../loader/components/Loader';
  import {mapGetters} from 'vuex';

  export default {
    components: {ConfirmModal, draggable, AddHintModal, Loader, TaskUsdModal},
    props: [
      'protocol',
      'isNew',
      'taskTypes',
      'selectedTaskTypeTitle',
      'selectedStagesTitle',
      'changeFromClient',
      'showDeleteButton',
      'transferConditionValue'],
    data() {
      return {
        apiUrl: '/protocols/',
        disabled: false,
        currentStageIndex: 0,
        currentStageTitle: '',
        currentStage: {},
        selectedStage: {},
        tasks: null,
        intervalError: false,
        addStimulusItem: null,
        selected: {},
        taskType: {},
        taskTypesList: [],
        tempCurrentStageAttemptCount: null,
        coldSampleIds: [1, 5],
        baseColdSample: 5,
        spoTaskTypes: [],
        disabledChange: false,
        errorPhaseCount: false,
        stimulList: [],
        isModalVisible: false,
        modal: null,
        stimul: null,
        isStimulVisible: false,
        dragging: false,
        modalView:false,
        afterLoad: false,
        hintLevel: null,
        hintLevelList: [],
        isModalHintVisible: false,
        selectedGroup: null,
        masteredLevels: null,
        mastering: null,
        isLoaded: false,
        isModalAcceptPopup: false,
        deletedSetItem: '',
        isModalDisablePopup:false,
        activeTask: null,
        intervals: [
          {typeId: 1, name: lang.get('protocol.through_each_lesson'), count: '3', checked: false, stimuli:[]},
          {typeId: 2, name: lang.get('protocol.after_one_lesson'), count: '3', checked: false, stimuli:[]},
          {typeId: 3, name: lang.get('protocol.after_two_classes'), count: '3', checked: false, stimuli:[]},
          {typeId: 4, name: lang.get('protocol.after_three_classes'), count: '3', checked: false, stimuli:[]},
          {typeId: 5, name: lang.get('protocol.once_a_week'), count: '3', checked: false, stimuli:[]},
          {typeId: 6, name: lang.get('protocol.once_every_two_weeks'), count: '3', checked: false, stimuli:[]},
          {typeId: 7, name: lang.get('protocol.once_a_month'), count: '3', checked: false, stimuli:[]},
        ],
        phases: [],
        condition_list: [9,18,27],
        acceptDeleteSetPopup: false,
        selectedIndex: null,
        selectedGroupIndex: null,
        msg: lang.get('protocol.enable_recording')
      };
    },
    computed: {

      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
      ]),

      isEmptySelectedStage: function() {
        return isEmpty(this.selectedStage);
      },
      taskTypesNew() {
        return this.taskTypes.filter((item) => {
          return item.title !== this.taskType.title;
        });
      },
      spoTaskTypesNew() {
        return this.spoTaskTypes.filter((item) => {
          return item.title !== this.spoTaskTypes.title;
        });
      },
      protocolStages() {
        return this.protocol.stages.filter((item) => {
          return item.title !== this.currentStage.title;
        });
      },
      activeStimulList(){
        return this.tasks.filter((item) => {
          return !item.levelUuid && item.phaseTypeId !== 3 && item.active;
        });
      }

    },

    mounted: function() {
      this.$nextTick(function() {
        this.intervalId = window.setInterval(() => {
          this.hideTasks();
        }, 5000);

      });
    },

    beforeDestroy() {
      clearInterval(this.intervalId)
    },

    methods: {

      acceptDeleteSet(index, groupIndex){
        this.selectedIndex = index;
        this.selectedGroupIndex = groupIndex;
        this.acceptDeleteSetPopup = true;
      },

      closeAcceptDeleteSetPopup(){
        this.deleteGroup(this.selectedIndex, this.selectedGroupIndex);
        this.cancelAcceptDeleteSetPopup();
      },

      cancelAcceptDeleteSetPopup(){
        this.acceptDeleteSetPopup = false;
      },
      
      levelTitle(index){
        return lang.get('protocol.level') + ' ' + (index+1) + ':';
      },

      onModalSave(phaseTask, interval){
        let support =  filter(this.currentStage.phases, item => { return item.typeId == 3; })[0];
        let mastering =  filter(this.currentStage.phases, function(item) { return item.typeId == 5; })[0];
        let intervalCurrent =  filter(support.intervals, item => { return this.stimul.intervalTypeId ? item.typeId === this.stimul.intervalTypeId : item.typeId === 1; })[0];

        if(this.stimul.phaseTypeId && this.stimul.phaseTypeId !== phaseTask){

          if(this.stimul.phaseTypeId === 5 && this.stimul.levelUuid){
            this.deleteSet(this.stimul);
          }

        }

        if(intervalCurrent && intervalCurrent.stimuli) {

          forEach(support.intervals, interval => {

            let stimulIndex = findIndex(interval.stimuli, item => {
              return item.globalUuid == this.stimul.globalUuid
            });

            if(stimulIndex >= 0 && interval.stimuli.length){
              interval.stimuli.splice(stimulIndex, 1);
            }


          });


        }

        
        let currentTask = filter(this.tasks, (task) => {
          return task.globalUuid === this.stimul.globalUuid;
        })[0];

        this.$set(currentTask, 'phaseTypeId', phaseTask);
        if(interval){
          this.$set(currentTask, 'intervalTypeId', toInteger(interval.typeId));
        }

        if(phaseTask == 3){
          let newInterval =  filter(support.intervals, item => { return item.typeId === interval.typeId; })[0];

          newInterval.stimuli.push(currentTask);
        }

        if(phaseTask == 5){
          
          if(mastering && !mastering.stimuli) {
            this.$set(mastering, 'stimuli', []);
          }

          mastering.stimuli.push(currentTask);


        }
        this.isModalVisible = false;
      },

      onModalCancel() {
        this.isModalHintVisible = false;
      },

      onModalUSDClose () {
        this.isModalVisible = false;
      },

      changeStimul(){
        this.isModalAcceptPopup = false;
        this.isModalVisible = true;
      },
      
      deleteSet(stimul){
        let level = filter(this.mastering.levels, level => {
          return level.uuid == stimul.levelUuid
        })[0];


        let groupIndex = findIndex(level.groups, group => {
          return group.uuid == stimul.levelGroupUuid
        });

        forEach(level.groups[groupIndex].stimuli, item => {

          let deleteTask = filter(this.tasks, deteted => {
            return deteted.globalUuid == item.globalUuid
          })[0];

          delete deleteTask['levelUuid'];


        });
        
        let listSetTasks = filter(this.tasks, task =>{
          return stimul.levelGroupUuid === task.levelGroupUuid
        });

        forEach(listSetTasks, task =>{
          delete task['levelUuid'];
          delete task['levelGroupUuid']
        });

        level.groups.splice(groupIndex, 1);
      },

      disableStimul(){
        this.deleteSet(this.activeTask);
        this.isModalDisablePopup = false;
      },

      closeStimul(){
        this.isModalAcceptPopup = false;
      },

      closeDisableStimul(){
        let currentTask = filter(this.tasks, (task) => {
          return task.globalUuid === this.activeTask.globalUuid;
        })[0];
        currentTask.active = true;
        this.isModalDisablePopup = false;
      },

      onModalClose(selectedStimulList) {

        let uuid = UuidGenerator.v4();

        map(this.tasks, (task) => {

          let currentTask = filter(selectedStimulList, function(item) {
            return item.globalUuid == task.globalUuid;
          });

          if (currentTask.length){
            this.$set(task, 'levelUuid', this.mastering.levels[this.selectedGroup].uuid);
            this.$set(task, 'levelGroupUuid', uuid);
            this.$set(task, 'phaseTypeId', 5);
          }

          return task;
        });


        if (!this.mastering.levels[this.selectedGroup].groups){
          this.mastering.levels[this.selectedGroup].groups = [];
        }

        this.mastering.levels[this.selectedGroup].groups.push({
          uuid: uuid,
          description: "набор " + this.mastering.levels[this.selectedGroup].groups.length,
          index: this.mastering.levels[this.selectedGroup].groups.length,
          stimuli: selectedStimulList
        });

        this.isModalHintVisible = false;
      },

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

      onEditBtnClick (item) {
        this.stimul = item;
        if (item.levelGroupUuid){
          this.listDeletedSetItem(item.levelGroupUuid)
          this.isModalAcceptPopup = true;
        } else {
          this.isModalVisible = true;
        }
      },
      
      listDeletedSetItem(levelGroupUuid){
        let list = join(map(filter(this.tasks, item => {
          return item.levelGroupUuid == levelGroupUuid;
        }), 'description'), ', ');
        this.deletedSetItem = lang.get('protocol.delete_set') + '\r\n' + lang.get('protocol.set') + ': ' + list;
      },

      getCurrentStageIndex: function(title) {
        this.currentStageIndex = findIndex(this.protocol.stages, (stage) => {
          return stage.title === title;
        });

        return this.currentStageIndex;
      },

      addTask: function(addStimulusItem) {
        if (!addStimulusItem){
          return;
        }

        let unique = true;

        let stimulList = this.protocol.globalTasks;

        forIn(stimulList, function(stimul) {
          if (trim(stimul.description.toLowerCase()) ===
              trim(addStimulusItem.toLowerCase())) {
            unique = false;
          }
        });

        if (unique) {
          this.currentStage.isNew = true;

          let position = parseInt(this.tasks.length) + 1;
          let uuid = UuidGenerator.v4();

          this.tasks.unshift({
            'id': null,
            'stageId': null,
            'typeId': 1,
            'globalTaskId': null,
            'position': position,
            'title': lang.get('protocol.stimulus') + ' ' + position,
            'description': addStimulusItem,
            'isNew': true,
            'active': true,
            'uuid': UuidGenerator.v4(),
            'globalUuid': uuid,
          });

          this.protocol.globalTasks.push({
            'id': null,
            'stageId': null,
            'fieldIndex': 1,
            'position': position,
            'title': lang.get('protocol.stimulus') + ' ' + position,
            'description': addStimulusItem,
            'isNew': true,
            'active': false,
            'uuid': uuid
          });


          this.addStimulusItem = null;
          this.changeCanPublish();

        } else {
          this.errors.add({
            field: 'addStimulusItem',
            msg: lang.get('rotation.unique_stimulus'),
          });
        }

      },

      addLevel(){
        this.mastering.levels.push({
          uuid: UuidGenerator.v4(),
          description: '',
          index: this.mastering.levels.length + 1,
          groups: []
        });
      },

      removeLevel(index){
        this.mastering.levels.splice(index, 1);
      },

      addGroup(index){
        this.selectedGroup = index;
        this.isModalHintVisible = true;
      },

      deleteGroup(index, groupIndex){
        
        this.isLoaded = false;

        let group = this.mastering.levels[index].groups[groupIndex];

        map(this.tasks, (task,index) => {

          let currentTask = filter(group.stimuli, function(item) {
            return item.globalUuid == task.globalUuid;
          });


          if (currentTask.length){
            delete task['levelUuid'];
            delete task['levelGroupUuid']
          }
          
          this.$set(this.tasks, index, task);

          return task;
        });
        

        this.mastering.levels[index].groups.splice(groupIndex, 1);
        this.isLoaded = true;

      },

      editProtocol() {
        this.$emit('editProtocol');
      },

      createProtocol() {
        this.$emit('createProtocol');
      },

      changeCanPublish() {
        this.$emit('changeCanPublish');
      },

      protocolChanged() {
        this.$emit('protocolChanged');
      },

      reindexStages: function() {
        this.tasks.forEach(function(item, index) {
          let position = parseInt(index);
          item['position'] = parseInt(index);
        });
      },

      async hideTasks(hide = false) {
        this.intervalError = false;
        this.disabled = true;
        let result = await this.$validator.validateAll();

        let protocol = this.protocol;
        protocol.stages[this.currentStageIndex] = this.currentStage;
        if (!result) {
          return;
        }

        let intervals = filter(protocol.stages[this.currentStageIndex].phases, function(item) { return item.typeId == 3; })[0];

        let intervalLenght = filter(this.intervals, function(val) { return val.checked; });
        if (!intervalLenght.length) {
          this.intervalError = true;
          this.disabled = false;
          return;
        }

        intervals.intervals = filter(this.intervals, function(val) { return val.checked; });

        protocol.stages[this.currentStageIndex].changed = true;
        protocol.stages[this.currentStageIndex].stimuli = filter(this.tasks, 'active');

        this.disabled = false;
        this.reindexStages();


        setTimeout(() => {
          this.protocol = protocol;
          if (hide){
            this.afterLoad = false;
            this.$emit('hideTasks');
          }
          this.protocolChanged();
        }, 100);
      },

      setStageGenerate: function() {
        if (!this.currentStage.hasOwnProperty('generate')) {
          this.currentStage['generate'] = {
            type: this.getSpoType(4),
            attempts: this.currentStage.attemptCount,
            answer: '-',
          };
        }

        if (isNull(this.currentStage.generate.type)) {
          this.currentStage.generate.type = this.getSpoType(4);
        }

        if (!isNull(this.currentStage.generate.attempts)) {
          this.currentStage.attemptCount = this.currentStage.generate.attempts;
        }
      },

      deleteStageGenerate: function() {
        if (this.currentStage.hasOwnProperty('generate')) {
          delete this.currentStage.generate;
        }
      },

      getSpoType: function(id) {
        let types = this.spoTaskTypes.filter(function(taskType) {
          return taskType.id === id;
        });

        return types.shift();
      },

      stimulDescrition(globalUuid){
        let currentTask = filter(this.protocol.globalTasks, function(item) {
          return item.uuid == globalUuid;
        });

        return currentTask.length ? currentTask[0].description : '';
      },

      currentIntervalType(typeId) {
        let currentInterval = null;
        if(typeId){
          currentInterval = filter(this.intervals, (interval) => {
            return interval.typeId == typeId;
          })[0];
        } else{
          currentInterval = filter(this.intervals, (interval) => {
            return interval.checked;
          })[0];
        }
        let currentIntervalName = currentInterval ? currentInterval.name : null;
        return currentIntervalName;
      },

      changeActive(task){
        if(!task.active && task.levelGroupUuid){
          this.listDeletedSetItem(task.levelGroupUuid)
          this.isModalDisablePopup = true;
          this.activeTask = task;
        }
      }

    },

    created() {
      if (this.selectedStagesTitle) {
        this.currentStageIndex = this.getCurrentStageIndex(
            this.selectedStagesTitle);
      }

      this.taskTypesList = filter(this.taskTypes, function(o) { return o.id == 1 || o.id == 4; });

      forEach(this.taskTypesList, (type) => {
        if (!(includes(this.coldSampleIds, type.id))) {
          this.spoTaskTypes.push(
              type,
          );
        }
      });

      this.currentStage = cloneDeep(this.protocol.stages[this.currentStageIndex]);

      this.currentStageTitle = this.currentStage.title;
      this.taskType = this.currentStage.type;
      this.mastering = filter(this.currentStage.phases, phase => {
        return phase.typeId == 5;
      })[0];
      
      

      this.support = filter(this.currentStage.phases, phase => {
        return phase.typeId == 3;
      })[0];


      if (!this.taskTypesList) {
        let index = 0;
        if (this.selectedTaskTypeTitle) {
          index = findIndex(this.taskTypesList, (task) => {
            return task.title === this.selectedTaskTypeTitle;
          });
        }
        this.taskType = this.taskTypesList[index];
      }

      let taskList = cloneDeep(this.protocol.globalTasks);

      this.tasks = map(taskList, (task) => {

        let currentTask = filter(this.currentStage.stimuli, function(item) {
          return item.globalUuid == task.uuid;
        });

        task.active = currentTask.length == 1;
        task.position = currentTask.length ? currentTask[0].position : task.position;
        task.globalUuid = task.uuid;
        if(task.active){
          task.levelUuid = currentTask[0].levelUuid;
          task.levelGroupUuid = currentTask[0].levelGroupUuid;
          task.phaseTypeId = currentTask[0].phaseTypeId;
          task.intervalTypeId = currentTask[0].intervalTypeId;
        }

        delete task['uuid'];

        return task;
      });

      this.tasks = sortBy(this.tasks, 'position');

      forEach(this.currentStage.phases, phase => {
        let title = phase.typeId === 3 ? lang.get('protocol.phase_support'): lang.get('protocol.phase_mastering');
        this.$set(phase, 'title', title);
      });

      let support =  filter(this.currentStage.phases, function(item) { return item.typeId == 3; });

      let intervals = support.length ? support[0].intervals : [];

      if (intervals.length) {

        forEach(intervals, (item) => {
          let index = findIndex(this.intervals, {
            typeId: item.type ? item.type.id : item.typeId
          });

          this.intervals[index].id = item.id
          this.intervals[index].count = item.count.toString()
          this.intervals[index].checked = true;
          this.intervals[index].stimuli = item.stimuli;
        });

      } else{
        this.intervals[0].checked = true;
      }

      this.setStageGenerate();

      setTimeout(() => {
        this.afterLoad = true;
        this.isLoaded = true;
      }, 100);

      Validator.extend('unique_task', {
        getMessage: attribute => lang.get('validation.unique_task',
            {attribute}),
        validate: async (task) => {
          let valid;
          let unique = 0;

          forIn(this.tasks, function(item) {
            if (item.description === task) {
              unique++;
            }
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });
    },

    watch: {

    }

  };
</script>


// WEBPACK FOOTER //
// src/modules/protocols/components/TasksUSD.vue